import Vue from 'vue';
import Router from 'vue-router';

const MidwarePage = r => require.ensure([], () => r(require('./router/MidwarePage.vue')), 'Others');

// 会员
const MemberList = r => require.ensure([], () => r(require('./router/MemberManage/MemberList/MemberList.vue')), 'MemberManage');
const AddMember = r => require.ensure([], () => r(require('./router/MemberManage/MemberList/AddMember.vue')), 'MemberManage');
const MemberDetail = r => require.ensure([], () => r(require('./router/MemberManage/MemberList/MemberDetail.vue')), 'MemberManage');

// 卡管理
const CardManage = r => require.ensure([], () => r(require('./router/MemberManage/CardManage/CardManage.vue')), 'MemberManage');
const MemberCardList = r => require.ensure([], () => r(require('./router/MemberManage/CardManage/MemberCardList.vue')), 'MemberManage');
const AnonymousCardList = r => require.ensure([], () => r(require('./router/MemberManage/CardManage/AnonymousCardList.vue')), 'MemberManage');
//const MemberCardType = r => require.ensure([], () => r(require('./router/MemberManage/MemberCard/MemberCardType.vue')), 'MemberManage');

// 微会员后台
const MicroMember = r => require.ensure([], () => r(require('./router/MemberManage/MicroMember/MicroMember.vue')), 'MemberManage');
const Authorization = r => require.ensure([], () => r(require('./router/MemberManage/MicroMember/Authorization.vue')), 'MemberManage');
const SettingDetail = r => require.ensure([], () => r(require('./router/MemberManage/MicroMember/SettingDetail.vue')), 'MemberManage');
const Attention = r => require.ensure([], () => r(require('./router/MemberManage/MicroMember/Attention.vue')), 'MemberManage');
const Setting = r => require.ensure([], () => r(require('./router/MemberManage/MicroMember/Setting.vue')), 'MemberManage');

const BatchCard = r => require.ensure([], () => r(require('./router/MemberManage/BatchCard/BatchCard.vue')), 'MemberManage');
const BatchCardList = r => require.ensure([], () => r(require('./router/MemberManage/BatchCard/BatchCardList.vue')), 'MemberManage');
const AnonymousBatchCard = r => require.ensure([], () => r(require('./router/MemberManage/BatchCard/AnonymousBatchCard.vue')), 'MemberManage');
const TransactionDetail = r => require.ensure([], () => r(require('./router/MemberManage/TransactionDetail/TransactionDetail.vue')), 'MemberManage');
const MemberLabel = r => require.ensure([], () => r(require('./router/MemberManage/MemberLabel/MemberLabel.vue')), 'MemberManage');

// 卡权益
const CardBenefits = r => require.ensure([], () => r(require('./router/MemberManage/CardRights/CardBenefits.vue')), 'MemberManage');
const CardTypeAdd = r => require.ensure([], () => r(require('./router/MemberManage/CardRights/CardTypeAdd.vue')), 'MemberManage');
const MemberBenefits = r => require.ensure([], () => r(require('./router/MemberManage/CardRights/MemberBenefits.vue')), 'MemberManage');
//匿名卡
const CardAnonymous = r => require.ensure([], () => r(require('./router/MemberManage/CardRights/CardAnonymous/cardAnonymous.vue')), 'MemberManage');
const CardAnonymousAdd = r => require.ensure([], () => r(require('./router/MemberManage/CardRights/CardAnonymous/cardAnonymousAdd.vue')), 'MemberManage');

// 营销管理
const FoodPromotionAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/FoodPromotion/FoodPromotionAdd.vue')), 'Marketing');
const FoodPromotionDetail = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/FoodPromotion/FoodPromotionDetail.vue')), 'Marketing');
const ActivityList = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/ActivityList.vue')), 'Marketing');
const ActivityAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/ActivityAdd.vue')), 'Marketing');
const BirthdayAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/Birthday/BirthdayAdd.vue')), 'Marketing');
const BirthdayDetail = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/Birthday/BirthdayDetail.vue')), 'Marketing');
const RechargeAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/Recharge/RechargeAdd.vue')), 'Marketing');
const RechargeDetail = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/Recharge/RechargeDetail.vue')), 'Marketing');
const ConsumeAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/Consume/ConsumeAdd.vue')), 'Marketing');
const ConsumeDetail = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/Consume/ConsumeDetail.vue')), 'Marketing');
const OpenCardAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/OpenCard/OpenCardAdd.vue')), 'Marketing');
const OpenCardDetail = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/OpenCard/OpenCardDetail.vue')), 'Marketing');
const PrecisionAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/PrecisionAdd/PrecisionAdd.vue')), 'Marketing');
const GroupConfig = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/PrecisionAdd/GroupConfig.vue')), 'Marketing');
const GroupList = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/PrecisionAdd/GroupList.vue')), 'Marketing');
const PullNewAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/PullNew/PullNewAdd.vue')), 'Marketing');
const PullNewDetail = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/PullNew/PullNewDetail.vue')), 'Marketing');
const Coupon = r => require.ensure([], () => r(require('./router/MarketingManage/Coupon/Coupon.vue')), 'Marketing');
const CouponUseDetail = r => require.ensure([], () => r(require('./router/MarketingManage/Coupon/CouponUseDetail.vue')), 'Marketing');
const AddCoupon = r => require.ensure([], () => r(require('./router/MarketingManage/Coupon/AddCoupon.vue')), 'Marketing');
const CouponDetail = r => require.ensure([], () => r(require('./router/MarketingManage/Coupon/CouponDetail.vue')), 'Marketing');
const PromotionList = r => require.ensure([], () => r(require('./router/MarketingManage/Promotion/PromotionList.vue')), 'Marketing');
const PromotionAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Promotion/PromotionAdd.vue')), 'Marketing');
const EvenHalfAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Promotion/EvenHalf/EvenHalfAdd.vue')), 'Marketing');
const BuyGiveAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Promotion/BuyGive/BuyGiveAdd.vue')), 'Marketing');
const SpecialOfferAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Promotion/SpecialOffer/SpecialOfferAdd.vue')), 'Marketing');
const DiscountAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Promotion/Discount/DiscountAdd.vue')), 'Marketing');
const FullReductionAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Promotion/FullReduction/FullReductionAdd.vue')), 'Marketing');
const AdditionalAdd = r => require.ensure([], () => r(require('./router/MarketingManage/Promotion/Additional/AdditionalAdd.vue')), 'Marketing');
const ActivityEffects = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/ActivityEffect.vue')), 'Marketing');
const Redpacketstatistics = r => require.ensure([], () => r(require('./router/MarketingManage/Activity/Redpacketstatistics.vue')), 'Marketing');

const CreditsExchange = r => require.ensure([], () => r(require('./router/MarketingManage/CreditsExchange/CreditsExchange.vue')), 'MarketingManage');
const ExchangeDetail = r => require.ensure([], () => r(require('./router/MarketingManage/CreditsExchange/ExchangeDetail.vue')), 'MarketingManage');
const ExchangePlan = r => require.ensure([], () => r(require('./router/MarketingManage/CreditsExchange/ExchangePlan.vue')), 'MarketingManage');
const Exchange = r => require.ensure([], () => r(require('./router/MarketingManage/CreditsExchange/Exchange.vue')), 'MarketingManage');
const CashGift = r => require.ensure([], () => r(require('./router/MarketingManage/CreditsExchange/CashGift.vue')), 'MarketingManage');
//营销管理--->活动统计
const Analysis = r => require.ensure([], () => r(require('./router/MarketingManage/Analysis/Analysis.vue')), 'Marketing');
//短信管理
const Message = r => require.ensure([], () => r(require('./router/MarketingManage/Message/Message.vue')), 'Marketing');
const MessageConfig = r => require.ensure([], () => r(require('./router/MarketingManage/Message/MessageConfig.vue')), 'Marketing');
const MessageMould = r => require.ensure([], () => r(require('./router/MarketingManage/Message/MessageMould.vue')), 'Marketing');

//报表管理
const StoredValueSummary = r => require.ensure([], () => r(require('./router/ReportManage/StoredValueSummary/StoredValueSummary.vue')), 'ReportManage');
const PaymentComposition = r => require.ensure([], () => r(require('./router/ReportManage/PaymentComposition/PaymentComposition.vue')), 'ReportManage');
const StoredValueBalance = r => require.ensure([], () => r(require('./router/ReportManage/StoredValueBalance/StoredValueBalance.vue')), 'ReportManage');
const StoreSettlement = r => require.ensure([], () => r(require('./router/ReportManage/StoreSettlement/StoreSettlement.vue')), 'ReportManage');
const IntegralSettlement = r => require.ensure([], () => r(require('./router/ReportManage/IntegralSettlement/IntegralSettlement.vue')), 'ReportManage');
const StoreSettlementDetail = r => require.ensure([], () => r(require('./router/ReportManage/StoreSettlement/StoreSettlementDetail.vue')), 'ReportManage');
const LocalConsumption = r => require.ensure([], () => r(require('./router/ReportManage/StoreSettlement/LocalConsumption.vue')), 'ReportManage');
const OtherConsumption = r => require.ensure([], () => r(require('./router/ReportManage/StoreSettlement/OtherConsumption.vue')), 'ReportManage');
const StoredReport = r => require.ensure([], () => r(require('./router/ReportManage/StoredReport.vue')), 'ReportManage');
const TradeSettlement = r => require.ensure([], () => r(require('./router/ReportManage/TradeSettlement/TradeSettlement.vue')), 'ReportManage');
const CashSettlement = r => require.ensure([], () => r(require('./router/ReportManage/CashSettlement/CashSettlement.vue')), 'ReportManage');


//经营分析
const MemberAnalysis = r => require.ensure([], () => r(require('./router/BizAnalysis/MemberAnalysis/MemberAnalysis.vue')), 'BizAnalysis');
const MemberProperty = r => require.ensure([], () => r(require('./router/BizAnalysis/MemberAnalysis/MemberProperty.vue')), 'BizAnalysis');
const MemberConsumeModel = r => require.ensure([], () => r(require('./router/BizAnalysis/MemberAnalysis/MemberConsumeModel.vue')), 'BizAnalysis');
const ValuableMember = r => require.ensure([], () => r(require('./router/BizAnalysis/MemberAnalysis/ValuableMember.vue')), 'BizAnalysis');
// const MemberRelationship = r => require.ensure([], () => r(require('./router/BizAnalysis/MemberAnalysis/MemberRelationship.vue')), 'BizAnalysis');

//全渠道 v1
const MemberArchivev1 = r => require.ensure([], () => r(require('./router/FullChannelv1/MemberArchive/MemberArchive.vue')), 'FullChannelv1');
const ActivityManagev1 = r => require.ensure([], () => r(require('./router/FullChannelv1/ActivityManage/ActivityManage.vue')), 'FullChannelv1');
const CreateActivityv1 = r => require.ensure([], () => r(require('./router/FullChannelv1/ActivityManage/CreateActivity.vue')), 'FullChannelv1');
const ActivityEffectv1 = r => require.ensure([], () => r(require('./router/FullChannelv1/ActivityManage/ActivityEffect.vue')), 'FullChannelv1');
const BusinessOpenv1 = r => require.ensure([], () => r(require('./router/FullChannelv1/BusinessOpen/BusinessOpen.vue')), 'FullChannelv1');
const Recognizev1 = r => require.ensure([], () => r(require('./router/FullChannelv1/BusinessOpen/Recognize.vue')), 'FullChannelv1');
const HqBusinessOpenv1 = r => require.ensure([], () => r(require('./router/FullChannelv1/HqBusinessOpen/HqBusinessOpen.vue')), 'FullChannelv1');
//全渠道 v2
const Summary = r => require.ensure([], () => r(require('./router/FullChannel/Summary/Summary.vue')), 'FullChannel');
const BusinessOpen = r => require.ensure([], () => r(require('./router/FullChannel/BusinessOpen/BusinessOpen.vue')), 'FullChannel');
const MarketingCenter = r => require.ensure([], () => r(require('./router/FullChannel/MarketingCenter/MarketingCenter.vue')), 'FullChannel');
const ActivityEdit = r => require.ensure([], () => r(require('./router/FullChannel/MarketingCenter/ActivityEdit.vue')), 'FullChannel');
const ActivityManage = r => require.ensure([], () => r(require('./router/FullChannel/ActivityManage/ActivityManage.vue')), 'FullChannel');
const ActivityEffect = r => require.ensure([], () => r(require('./router/FullChannel/ActivityManage/ActivityEffect.vue')), 'FullChannel');
const ActivityAnalysis = r => require.ensure([], () => r(require('./router/FullChannel/ActivityAnalysis/ActivityAnalysis.vue')), 'FullChannel');

//消息中心
const MessageCenter = r => require.ensure([], () => r(require('./router/MessageCenter/MessageCenter.vue')), 'Others');

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/Midware',
      name: 'Midware',
      component: MidwarePage
    },
    {
      path: '/MessageCenter',
      name: 'MessageCenter',
      component: MessageCenter,
      meta: {
        title: '消息中心'
      }
    },
    {
      path: '/MemberManage/MemberList',
      name: 'MemberList',
      component: MemberList,
      meta: {
        cid: 'c_eco_kp6huzx1'
      }
    },
    {
      path: '/MemberManage/MemberList/AddMember',
      name: 'AddMember',
      component: AddMember,
      meta: {
        title: [{
          name: '会员',
          path: '/MemberManage/MemberList'
        }, {
          name: '添加会员'
        }]
      }
    },
    {
      path: '/MemberManage/MemberList/MemberDetail/:id',
      name: 'MemberDetail',
      component: MemberDetail,
      meta: {
        title: [{
          name: '会员',
          path: '/MemberManage/MemberList'
        }, {
          name: '查看会员详情',
        }]
      }
    },
    {
      path: '/MemberManage/CardManage',
      component: CardManage,
      children: [
        {
          path: '',
          name: 'MemberCardList',
          component: MemberCardList,
          meta: {
            cid: 'c_eco_8icof6ky'
          }
        },
        {
          path: 'AnonymousCardList',
          name: 'AnonymousCardList',
          component: AnonymousCardList,
          meta: {
            cid: 'c_eco_0sdx1xva'
          }
        }
      ]
    },
    {
      path: '/MemberManage/MicroMember',
      component: MicroMember,
      children: [
        {
          path: '',
          name: 'Authorization',
          component: Authorization,
          meta: {
            cid: 'c_eco_2zoul1oj'
          }
        },
        {
          path: 'SettingDetail',
          name: 'SettingDetail',
          component: SettingDetail,
        },
        {
          path: 'Setting',
          name: 'Setting',
          component: Setting,
        },
        {
          path: 'Attention',
          name: 'Attention',
          component: Attention,
        }
      ]
    },
    {
      path: '/MemberManage/CardRights',
      component: MemberBenefits,
      meta: {
        title:'卡权益设置',
        cid: 'c_eco_2a2p0k96'
      },
      children: [{
        path: '',
        name: 'CardBenefits',
        component: CardBenefits,
        meta: {
          title:'卡权益配置',
          cid: 'c_eco_2a2p0k96'
        }
      },{
        path: 'CardAnonymous',
        name: 'CardAnonymous',
        component: CardAnonymous,
        meta: {
          title:'卡权益配置',
          cid: 'c_eco_yhm7fru2'
        }
      }]
    },
    {
      path: '/MemberManage/CardRights/CardTypeAdd',
      name: 'CardTypeAdd',
      component: CardTypeAdd,
      meta: {
        title: [
          {name: '卡权益', path: '/MemberManage/CardRights/CardAnonymous'},
          {name: '卡权益配置流程'}
        ]
      }
    },
    {
      path: '/MemberManage/CardRights/CardAnonymous/cardAnonymousAdd',
      name: 'cardAnonymousAdd',
      component: CardAnonymousAdd,
      meta: {
        title: [
            {name: '卡权益', path: '/MemberManage/CardRights/CardAnonymous'},
            {name: '新增'}
        ]
      }
    },
    {
      path: '/MemberManage/BatchCard',
      component: BatchCard,
      children: [
        {
          path: '',
          name: 'BatchCardList',
          component: BatchCardList,
          meta: {
            cid: 'c_eco_jj3tzfar'
          }
        },{
          path: 'AnonymousBatchCard',
          name: 'AnonymousBatchCard',
          component: AnonymousBatchCard
        }
      ]
    },
    {
      path: '/MemberManage/TransactionDetail',
      name: 'TransactionDetail',
      component: TransactionDetail,
      meta: {
        cid: 'c_eco_y4zfsaec'
      }
    },
    {
      path: '/MemberManage/MemberLabel',
      name: 'MemberLabel',
      component: MemberLabel,
      meta: {
        cid: 'c_eco_jjss476k'
      }
    },
    {
      path: '/MarketingManage/ActivityList',
      name: 'ActivityList',
      component: ActivityList,
      meta: {
        cid: 'c_eco_qwv9e9ft'
      }
    },
    {
      path: '/MarketingManage/ActivityAdd',
      name: 'ActivityAdd',
      component: ActivityAdd,
      meta: {
        cid:'c_x1s3bm2b'
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/BirthdayAdd',
      name: 'BirthdayAdd',
      component: BirthdayAdd,
      meta: {
        title: [{
          name: '会员活动',
          path: '/MarketingManage/ActivityAdd'
        }, {
          name: '生日赠券',
        }],
        cid: 'c_eco_kb2cshjq'
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/BirthdayDetail',
      name: 'BirthdayDetail',
      component: BirthdayDetail,
      meta: {
        title: [{
          name: '活动管理',
          path: '/MarketingManage/ActivityList'
        }, {
          name: '生日赠券',
        }]
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/RechargeAdd',
      name: 'RechargeAdd',
      component: RechargeAdd,
      meta: {
        title: [{
          name: '会员活动',
          path: '/MarketingManage/ActivityAdd'
        }, {
          name: '储值赠券',
        }],
        cid: 'c_eco_znjkhf9w'
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/RechargeDetail',
      name: 'RechargeDetail',
      component: RechargeDetail,
      meta: {
        title: [{
          name: '活动管理',
          path: '/MarketingManage/ActivityList'
        }, {
          name: '储值赠券',
        }]
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/ConsumeAdd',
      name: 'ConsumeAdd',
      component: ConsumeAdd,
      meta: {
        title: [{
          name: '会员活动',
          path: '/MarketingManage/ActivityAdd'
        }, {
          name: '消费满额赠券',
        }],
        cid: 'c_eco_jf7xyn2w'
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/ConsumeDetail',
      name: 'ConsumeDetail',
      component: ConsumeDetail,
      meta: {
        title: [{
          name: '活动管理',
          path: '/MarketingManage/ActivityList'
        }, {
          name: '消费满额赠券',
        }]
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/OpenCardAdd',
      name: 'OpenCardAdd',
      component: OpenCardAdd,
      meta: {
        title: [{
          name: '会员活动',
          path: '/MarketingManage/ActivityAdd'
        }, {
          name: '开卡赠券',
        }],
        cid: 'c_eco_lfihdmru'
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/OpenCardDetail',
      name: 'OpenCardDetail',
      component: OpenCardDetail,
      meta: {
        title: [{
          name: '活动管理',
          path: '/MarketingManage/ActivityList'
        }, {
          name: '开卡赠券'
        }]
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/PrecisionAdd',
      component: PrecisionAdd,
      children: [{
        path: '',
        name: 'GroupConfig',
        component: GroupConfig,
        meta: {
          title: [{
            name: '会员活动',
            path: '/MarketingManage/ActivityAdd'
          }, {
            name: '精准营销',
          }],
          cid: 'c_eco_u2h0jusi'
        }
      }, {
        path: 'GroupList',
        name: 'GroupList',
        component: GroupList,
        meta: {
          title: [{
            name: '会员活动',
            path: '/MarketingManage/ActivityAdd'
          }, {
            name: '精准营销',
          }],
          cid: 'c_eco_d6ls6eog'
        }
      }]
    },
    {
      path: '/MarketingManage/ActivityAdd/PullNewAdd',
      name: 'PullNewAdd',
      component: PullNewAdd,
      meta: {
        title: [{
          name: '会员活动',
          path: '/MarketingManage/ActivityAdd'
        }, {
          name: '红包活动',
        }]
      }
    },
    {
      path: '/MarketingManage/ActivityAdd/PullNewDetail',
      name: 'PullNewDetail',
      component: PullNewDetail,
      meta: {
        title: [{
          name: '活动管理',
          path: '/MarketingManage/ActivityList'
        }, {
          name: '红包活动',
        }]
      }
    },
    {    //  定食营销
      path: '/MarketingManage/ActivityAdd/FoodPromotionAdd',
      name: 'FoodPromotionAdd',
      component: FoodPromotionAdd,
      meta: {
        title: [{
          name: '会员活动',
          path: '/MarketingManage/ActivityAdd'
        }, {
          name: '定食营销',
        }],
        cid: 'c_u3laem2x'
      }
    },
    {    //  定食营销
      path: '/MarketingManage/ActivityAdd/FoodPromotionDetail',
      name: 'FoodPromotionDetail',
      component: FoodPromotionDetail,
      meta: {
        title: [{
          name: '会员活动',
          path: '/MarketingManage/FoodPromotionDetail'
        }, {
          name: '定食营销',
        }]
      }
    },
    {
      path: '/MarketingManage/ActivityList/ActivityEffects',
      name: 'ActivityEffects',
      component: ActivityEffects,
      meta: {
        title: [{
          name: '会员活动管理',
          path: '/MarketingManage/ActivityList'
        },{
          name:'活动效果'
        }]
      }
    },
    {
      path: '/MarketingManage/ActivityList/Redpacketstatistics',
      name: 'Redpacketstatistics',
      component: Redpacketstatistics,
      meta: {
        title: [{
          name: '会员活动管理',
          path: '/MarketingManage/ActivityList'
        },{
          name:'红包统计'
        }]
      }
    },
    {
      path: '/MarketingManage/Analysis',
      name: 'Analysis',
      component: Analysis,
      meta: {
        title: [{
          name: '营销活动统计'
        }]
      }
    },
    {
      path: '/MarketingManage/Coupon',
      name: 'Coupon',
      component: Coupon,
      meta: {
        cid: 'c_eco_17ngxn9r'
      }
    },
    {
      path: '/MarketingManage/Coupon/AddCoupon',
      name: 'AddCoupon',
      component: AddCoupon,
      meta: {
        title: [
          {name: '优惠券管理', path: '/MarketingManage/Coupon'},
          {name: '新增优惠券'}
        ]
      }
    },
    {
      path: '/MarketingManage/Coupon/CouponDetail',
      name: 'CouponDetail',
      component: CouponDetail,
      meta: {
        title: [
          {name: '优惠券管理', path: '/MarketingManage/Coupon'},
          {name: '查看优惠券'}
        ]
      }
    },
    {
      path: '/MarketingManage/Coupon/CouponUseDetail',
      name: 'CouponUseDetail',
      component: CouponUseDetail,
      meta: {
        title: [
          {name: '优惠券管理', path: '/MarketingManage/Coupon'},
          {name: '优惠券使用详情'}
        ]
      }
    },
    {
      path: '/MarketingManage/PromotionList',
      name: 'PromotionList',
      component: PromotionList
    },
    //促销活动
    {
      path: '/MarketingManage/PromotionAdd',
      name: 'PromotionAdd',
      component: PromotionAdd
    },
    {
      path: '/MarketingManage/PromotionAdd/EvenHalfAdd',
      name: 'EvenHalfAdd',
      component: EvenHalfAdd,
      meta: {
        title: [{
          name: '促销活动',
          path: '/MarketingManage/PromotionAdd'
        }, {
          name: '偶数份半价',
        }]
      }
    },
    {
      path: '/MarketingManage/PromotionAdd/BuyGiveAdd',
      name: 'BuyGiveAdd',
      component: BuyGiveAdd,
      meta: {
        title: [{
          name: '促销活动',
          path: '/MarketingManage/PromotionAdd'
        }, {
          name: '买X赠Y',
        }]
      }
    },
    {
      path: '/MarketingManage/PromotionAdd/SpecialOfferAdd',
      name: 'SpecialOfferAdd',
      component: SpecialOfferAdd,
      meta: {
        title: [{
          name: '促销活动',
          path: '/MarketingManage/PromotionAdd'
        }, {
          name: '特价',
        }]
      }
    },
    {
      path: '/MarketingManage/PromotionAdd/DiscountAdd',
      name: 'DiscountAdd',
      component: DiscountAdd,
      meta: {
        title: [{
          name: '促销活动',
          path: '/MarketingManage/PromotionAdd'
        }, {
          name: '折扣',
        }]
      }
    },
    {
      path: '/MarketingManage/PromotionAdd/FullReductionAdd',
      name: 'FullReductionAdd',
      component: FullReductionAdd,
      meta: {
        title: [{
          name: '促销活动',
          path: '/MarketingManage/PromotionAdd'
        }, {
          name: '满减',
        }]
      }
    },
    {
      path: '/MarketingManage/PromotionAdd/AdditionalAdd',
      name: 'AdditionalAdd',
      component: AdditionalAdd,
      meta: {
        title: [{
          name: '促销活动',
          path: '/MarketingManage/PromotionAdd'
        }, {
          name: '加价购',
        }]
      }
    },
    //短信管理
    {
      path: '/MarketingManage/Message',
      component: Message,
      children: [
        {
          path: '',
          name: 'MessageMould',
          component: MessageMould,
          meta: {
            cid: 'c_eco_d3sfdw2k'
          }
        },
        {
          path: 'MessageConfig',
          name: 'MessageConfig',
          component: MessageConfig,
          meta: {
            cid: 'c_eco_9wwpot8p'
          }
        }
      ]
    },
    {
      path: '/MarketingManage/CreditsExchange',
      component: CreditsExchange,
      children: [
        {
          path: '',
          name: 'ExchangeDetail',
          component: ExchangeDetail,
          meta: {
            cid: 'c_eco_nkua2365'
          }
        },
        {
          path: 'ExchangePlan',
          name: 'ExchangePlan',
          component: ExchangePlan,
          meta: {
            cid: 'c_eco_try8h2yf'
          }
        },
        {
          path: 'Exchange',
          name: 'Exchange',
          component: Exchange,
          meta: {
            cid: 'c_eco_e0zee3xz'
          }
        }
      ]
    },
    {
      path: '/MarketingManage/CreditsExchange/CashGift',
      name: 'CashGift',
      component: CashGift,
      meta: {
        title:[{
          name:'积分兑换方案',
          path:'/MarketingManage/CreditsExchange/ExchangePlan'
        },{
          name:'添加积分方案',
        }]
      }
    },
    //经营分析
    {
      path: '/BizAnalysis/MemberAnalysis',
      name: 'MemberAnalysis',
      component: MemberAnalysis,
      meta: {
        cid: 'c_eco_w7lslhs9'
      }
    },
    {
      path: '/BizAnalysis/MemberProperty',
      name: 'MemberProperty',
      component: MemberProperty
    },
    {
      path: '/BizAnalysis/MemberConsumeModel',
      name: 'MemberConsumeModel',
      component: MemberConsumeModel
    },
    {
      path: '/BizAnalysis/ValuableMember',
      name: 'ValuableMember',
      component: ValuableMember
    },
    // {
    //   path: '/BizAnalysis/MemberRelationship',
    //   name: 'MemberRelationship',
    //   component: MemberRelationship
    // },

    //报表管理
    // {
    //   path: '/ReportManage/StoredReport',
    //   name: 'StoredReport',
    //   component: StoredReport
    // },
    {
      path: '/ReportManage/StoredValueSummary',
      name: 'StoredValueSummary',
      component: StoredValueSummary,
      meta: {
        cid: 'c_eco_co61ir10'
      }
      // meta: {
      //   title: [{
      //     name: '储值报表类',
      //     path: '/ReportManage/StoredReport'
      //   }, {
      //     name: '储值汇总表',
      //   }]
      // }
    },
    {
      path: '/ReportManage/PaymentComposition',
      name: 'PaymentComposition',
      component: PaymentComposition,
      meta: {
        cid: 'c_eco_ncyiiqai'
      }
      // meta: {
      //   title: [{
      //     name: '储值报表类',
      //     path: '/ReportManage/StoredReport'
      //   }, {
      //     name: '储值支付方式组成表',
      //   }]
      // }
    },
    {
      path: '/ReportManage/CashSettlement',
      name: 'CashSettlement',
      component: CashSettlement,
      meta: {
        cid: 'c_eco_n4z5b9ps'
      }
      // meta: {
      //   title: [{
      //     name: '储值报表类',
      //     path: '/ReportManage/StoredReport'
      //   }, {
      //     name: '门店储值现金结算表',
      //   }]
      // }
    },
    {
      path: '/ReportManage/StoredValueBalance',
      name: 'StoredValueBalance',
      component: StoredValueBalance,
      meta: {
        cid: 'c_eco_5a8tyttz'
      }
      // meta: {
      //   title: [{
      //     name: '储值报表类',
      //     path: '/ReportManage/StoredReport'
      //   }, {
      //     name: '储值余额汇总表',
      //   }]
      // }
    },
    {
      path: '/ReportManage/StoreSettlement',
      name: 'StoreSettlement',
      component: StoreSettlement,
      meta: {
        cid: 'c_eco_ej8xgd08'
      }
      // meta: {
      //   title: [{
      //     name: '储值报表类',
      //     path: '/ReportManage/StoredReport'
      //   }, {
      //     name: '门店结算报表',
      //   }]
      // }
    },
    {
      path: '/ReportManage/TradeSettlement',
      name: 'TradeSettlement',
      component: TradeSettlement,
      meta: {
        cid: 'c_eco_dsgnpvn6'
      }
      // meta: {
      //   title: [{
      //     name: '储值报表类',
      //     path: '/ReportManage/StoredReport'
      //   }, {
      //     name: '门店储值交易结算表',
      //   }]
      // }
    },
    {
      path: '/ReportManage/StoreSettlement/StoreSettlementDetail',
      component: StoreSettlementDetail,
      children: [{
        path: '',
        name: 'OtherConsumption',
        component: OtherConsumption,
        meta: {
          title: [
            {name: '门店结算报表', path: '/ReportManage/StoreSettlement'},
            {name: '消费金额（他在本）'}
          ]
        }
      }, {
        path: 'LocalConsumption',
        name: 'LocalConsumption',
        component: LocalConsumption,
        meta: {
          title: [
            {name: '门店结算报表', path: '/ReportManage/StoreSettlement'},
            {name: '消费金额（本在他）'}
          ]
        }
      }]
    },
    {
      path: '/ReportManage/IntegralSettlement',
      name: 'IntegralSettlement',
      component: IntegralSettlement,
      meta: {
        cid: 'c_eco_4ecsprm0'
      }
    },
    //全渠道 v1
    //全渠道
    {
      path: '/FullChannel/v1/MemberArchive',
      name: 'MemberArchivev1',
      component: MemberArchivev1
    },
    {
      path: '/FullChannel/v1/ActivityManage',
      name: 'ActivityManagev1',
      component: ActivityManagev1
    }, {
      path: '/FullChannel/v1/ActivityManage/CreateActivity',
      name: 'CreateActivityv1',
      component: CreateActivityv1,
      meta: {
        title: [
          {name: '活动管理', path: '/FullChannel/v1/ActivityManage'},
          {name: '创建活动'}
        ]
      }
    },
    {
      path: '/FullChannel/v1/ActivityManage/ActivityEffect/:id',
      name: 'ActivityEffectv1',
      component: ActivityEffectv1,
      meta: {
        title: [{
          name: '活动管理',
          path: '/FullChannel/v1/ActivityManage'
        }, {
          name: '活动效果',
        }]
      }
    },
    {
      path: '/FullChannel/v1/BusinessOpen',
      name: 'BusinessOpenv1',
      component: BusinessOpenv1
    },
    {
      path: '/FullChannel/v1/HqBusinessOpen',
      name: 'HqBusinessOpen',
      component: HqBusinessOpenv1
    },
    {
      path: '/FullChannel/v1/BusinessOpen/Recognize',
      name: 'Recognizev1',
      component: Recognizev1
    },
    //全渠道 v2
    {
      path: '/FullChannel/Summary',
      name: 'Summary',
      component: Summary,
      meta: {
        cid: 'c_5fs8kc14'
      }
    },
    {
      path: '/FullChannel/BusinessOpen',
      name: 'BusinessOpen',
      component: BusinessOpen,
      meta: {
        cid: 'c_l5ugbfub'
      }
    },
    {
      path: '/FullChannel/BusinessOpen-BD',
      name: 'BusinessOpen-BD',
      component: BusinessOpen,
      meta: {
        cid: 'c_chqm54wb'
      }
    },
    {
      path: '/FullChannel/MarketingCenter',
      name: 'MarketingCenter',
      component: MarketingCenter,
      meta: {
        cid: 'c_0cuwhb94'
      }
    },
    {
      path: '/FullChannel/MarketingCenter/ActivityEdit/:type/:id?',
      name: 'ActivityEdit',
      component: ActivityEdit,
      meta: {
        title: [
          { name: '营销中心', path: '/FullChannel/MarketingCenter' },
          { name: '创建营销活动' }
        ]
      }
    },
    {
      path: '/FullChannel/ActivityManage',
      name: 'ActivityManage',
      component: ActivityManage,
      meta: {
        cid: 'c_cg2f6j1c'
      }
    },
    {
      path: '/FullChannel/ActivityManage/ActivityEffect/:id',
      name: 'ActivityEffect',
      component: ActivityEffect,
      meta: {
        title: [
          { name: '活动管理', path: '/FullChannel/ActivityManage' },
          { name: '活动效果' }
        ]
      }
    },
    {
      path: '/FullChannel/ActivityAnalysis',
      name: 'ActivityAnalysis',
      component: ActivityAnalysis,
      meta: {
        cid: 'c_7g19q47m',
      }
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router.js